import React from 'react'
import Proposal from './Proposal'
import AllProposals from './AllProposals'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import RequestSuccess, { RequestSuccessV2 } from './RequestSuccess'
import { EventHub } from './EventHub'
import { ROUTES } from '../Constants'

const Home: React.FC = () => {
  return (
    <Router basename='/smart-book-events'>
      <Switch>
        <Route path={`${ROUTES.PROPOSAL}/:proposalUUID`}>
          <Proposal />
        </Route>
        <Route path={`${ROUTES.ALL_PROPOSALS}/:eventUUID`}>
          <AllProposals />
        </Route>
        <Route path={ROUTES.CONFIRMATION}>
          <RequestSuccess />
        </Route>
        <Route path={ROUTES.CONFIRMATION_V2}>
          <RequestSuccessV2 />
        </Route>
        <Route path={ROUTES.EVENT_HUB}>
          <EventHub />
        </Route>
      </Switch>
    </Router>
  )
}

export default Home
